import React, { useState, useEffect } from "react";
import Home from './pages/Home';
import Presale from './pages/Presale';
import Playgame from './pages/Playgame';
import Marketplace from './pages/Marketplace';
import { Route, Routes } from "react-router-dom";
import { Navbar } from './components/organisms';
import Music from './assets/music/Music.mp3'
import ReactAudioPlayer from 'react-audio-player';

function App() {
  // const [audio] = useState(new Audio(Music));

  // useEffect(() => {
  //   document.body.addEventListener("load", () => {
  //     const audioEl = document.getElementsByClassName("audio-element")[0]
  //     audioEl.play()
  //   })
  // }, []);

  return (
    <div className="App">
      {/* <audio autoPlay loop muted>
        <source src={Music} type="audio/mpeg"></source>
      </audio> */}
      <Navbar />
      <ReactAudioPlayer
        src={Music}
        autoPlay
        loop
      />
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/presale" element={<Presale />} />
          <Route path="/playgame" element={<Playgame />} />
          <Route path="/marketplace" element={<Marketplace />} />
      </Routes>
    </div>
  );
}

export default App;
